var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('a-modal',{staticClass:"modal-overflow-visible",attrs:{"ok-text":_vm.$t('add_button'),"cancel-text":_vm.$t('cancel_button'),"cancel-button-props":{
      props: {
        disabled: _vm.creating ,
      }
    },"ok-button-props":{
      props: {
        disabled: _vm.creating || invalid,
        loading: _vm.creating
      }
    }},on:{"ok":_vm.createProperty,"cancel":_vm.resetFields},model:{value:(_vm.modalIsOpen),callback:function ($$v) {_vm.modalIsOpen=$$v},expression:"modalIsOpen"}},[_c('div',{staticClass:"flex",attrs:{"slot":"title"},slot:"title"},[_vm._v(" "+_vm._s(_vm.$t('create_new_property'))+" "),_c('sup',[_c('help-message',{attrs:{"help-message":_vm.$t('create_new_property_help_message')}})],1)]),_c('text-input',{key:("text-input-" + _vm.template),attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.context,
          'key': 'newPropertyName',
          'prefix': "create_new_property_",
          'validation': 'required|alpha_num_spaces'
        }
      }}}),_c('select-input',{key:("select-input-" + _vm.template),attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.context,
          'key': 'newPropertyType',
          'options': _vm.typesOptions,
          'prefix': "create_new_property_",
          'clearable': false,
        }
      }}}),(_vm.extraView(_vm.context.newPropertyType))?_c(_vm.extraView(_vm.context.newPropertyType),{tag:"component",model:{value:(_vm.context.propertyData),callback:function ($$v) {_vm.$set(_vm.context, "propertyData", $$v)},expression:"context.propertyData"}}):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }